var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.5,19.2L25,17v4.4c3.3,0,6.1,2.7,6.1,6.1s-2.7,6.1-6.1,6.1V39C35.7,35.2,33.5,19.2,33.5,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.9,27.4c0-3.3,2.7-6.1,6.1-6.1V17l-8.5,2.2c0,0-2.1,15.9,8.5,19.8v-5.5C21.7,33.5,18.9,30.8,18.9,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,22.4c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4C22.6,23.5,23.7,22.4,25,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.7,31.3c-1.1,1.4-2.8,2.2-4.7,2.2c-1.9,0-3.6-0.9-4.7-2.2c0.7-1.9,2.6-3.2,4.7-3.2S29,29.4,29.7,31.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsDefault);
export default __webpack_public_path__ + "static/media/accounts-default.5ccee2cf30dd8b7b784930d858c01890.svg";
export { ForwardRef as ReactComponent };